<template>
  <main-wrapper>
    <router-view/>
  </main-wrapper>
</template>

<style lang="scss">
@import 'node_modules/bootstrap/scss/bootstrap.scss';
@import '../../node_modules/vue-wysiwyg/dist/vueWysiwyg.css';
@import 'assets/stylesheets/main.scss';
</style>

<script>
import { mapGetters } from 'vuex'
import mainWrapper from './main-wrapper'

export default {
  components: {
    mainWrapper
  },
  computed: {
    ...mapGetters({
      authenticated: 'token/authenticated'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/app.vue